import React, { useEffect, useContext, useState, useReducer } from "react";
import Loading from "./Loading";
import * as APICalls from "./JsFiles/APICalls";
import Accesses from "./JsFiles/Accesses";
import {
  decodedTokenObjectContext,
  workItemObjectContext,
  userInfoObjectContext,
  accessesObjectContext,
  messageBoxContext,
  errorBoxContext,
} from "./App";

import "../style/verktoy.css";

var allUsersInfo = {};

export default function Verktoy() {
  const [userInfoObject, setUserInfoObject] = useContext(userInfoObjectContext);
  const [workItemObject, setWorkItemObject] = useContext(workItemObjectContext);
  const [accessesObject, setAccessesObject] = useContext(accessesObjectContext);
  const [decodedTokenObject, setDecodedTokenObject] = useContext(decodedTokenObjectContext);
  let setMessageBoxProp = useContext(messageBoxContext);
  let setErrorBoxProp = useContext(errorBoxContext);
  const [reloadVerktoy, setReloadVerktoy] = useState(false);

  const [setReviewButtonStatus, setSetReviewButtonStatus] = useState(false);
  const [usersInfoStatus, setUsersInfoStatus] = useState("loading");

  //force updating this component
  const forceUpdate = useReducer((x) => x + 1, 0)[1];

  let AllReviewersApproved = AllReviewersHaveApproved();
  const handleUpdate = () => {
    APICalls.getWorkItemInfo(decodedTokenObject).then((result) => {
      setWorkItemObject((workItemObject) => {
        return Object.assign(workItemObject, result);
      });
      setAccessesObject((accessesObject) => {
        return Object.assign(accessesObject, Accesses(userInfoObject, workItemObject));
      });
      forceUpdate();
      setReloadVerktoy(!reloadVerktoy);
      AllReviewersApproved = AllReviewersHaveApproved();
    });
  };

  useEffect(() => {
    loadAllUserInfo();
  }, []);

  useEffect(() => {
    if (usersInfoStatus == "finished") {
      revision();
      deling();
      fagligVurdering();
      publisering();
    }
  }, [reloadVerktoy, workItemObject, accessesObject, usersInfoStatus]);

  async function revision() {
    if (accessesObject.CanViewRevision) {
      if (workItemObject.ContentReviewer?.Id && workItemObject.ContentReviewer?.Id != null) {
        const contentReviewerId = workItemObject.ContentReviewer.Id;
        getUserName(contentReviewerId).then((name) => {
          let contentReviewerText = document.querySelector(".contentReviewerText");
          let contentReviewerCheckbox = document.querySelector(".contentReviewerCheckbox");
          contentReviewerText.innerText = "Aktiver fagredaktør (" + name + ")";
          if (workItemObject.ContentReviewer?.EnableOnRevision == null) {
            contentReviewerCheckbox.disabled = false;
          } else {
            contentReviewerCheckbox.checked = true;
            contentReviewerCheckbox.disabled = true;
            contentReviewerText.innerText = "Fagredaktør(" + name + ") er aktivert.";
          }
        });
      }
      if (workItemObject.EUReviewer?.Id && workItemObject.EUReviewer.Id != null) {
        const euReviewerId = workItemObject.EUReviewer.Id;
        getUserName(euReviewerId).then((name) => {
          let euReviewerText = document.querySelector(".euReviewerText");
          let euReviewerCheckbox = document.querySelector(".euReviewerCheckbox");
          euReviewerText.innerText = "Aktiver EU redaktør (" + name + ")";
          if (workItemObject.EUReviewer?.EnableOnRevision == null) {
            euReviewerCheckbox.disabled = false;
          } else {
            euReviewerCheckbox.checked = true;
            euReviewerCheckbox.disabled = true;
            euReviewerText.innerText = "EU redaktør(" + name + ") er aktivert.";
          }
        });
      }
      if (workItemObject.ProofReader?.Id && workItemObject.ProofReader.Id != null) {
        const proofReaderId = workItemObject.ProofReader.Id;
        getUserName(proofReaderId).then((name) => {
          let proofReaderText = document.querySelector(".proofReaderText");
          let proofReaderCheckbox = document.querySelector(".proofReaderCheckbox");
          proofReaderText.innerText = "Aktiver korrekturleser (" + name + ")";
          if (workItemObject.ProofReader?.EnableOnRevision == null) {
            proofReaderCheckbox.disabled = false;
          } else {
            proofReaderCheckbox.checked = true;
            proofReaderCheckbox.disabled = true;
            proofReaderText.innerText = "Korrekturleser(" + name + ") er aktivert.";
          }
        });
      }
    }
  }

  async function deling() {
    if (accessesObject.CanViewCoAuthors) {
      if (workItemObject.AuthorName) {
        document.querySelector(".authorName").innerText = workItemObject.AuthorName;
      }
      let coAuthorLenght;
      workItemObject.SharedWith
        ? (coAuthorLenght = workItemObject.SharedWith.length)
        : (coAuthorLenght = 0);

      if (coAuthorLenght > 0) {
        let coAuthorsDiv = document.querySelector(".coAuthorNames");
        coAuthorsDiv.replaceChildren();
        for (let index = 0; index < coAuthorLenght; index++) {
          const coAuthorId = workItemObject.SharedWith[index];
          getUserName(coAuthorId).then((name) => {
            let coAuthorNameDiv = createHtmlElement("div", "verktoyHeadings4", null, name);
            coAuthorsDiv.appendChild(coAuthorNameDiv);
          });
        }
      }
    }
  }

  async function fagligVurdering() {
    let contentReviewerNameSpan = document.querySelector(".contentReviewerName");
    let euReviewerNameSpan = document.querySelector(".euReviewerName");
    let proofReaderNameSpan = document.querySelector(".proofReaderName");

    if (contentReviewerNameSpan) {
      getUserName(workItemObject.ContentReviewer.Id).then((name) => {
        contentReviewerNameSpan.innerText = name;
      });
    }
    if (euReviewerNameSpan) {
      getUserName(workItemObject.EUReviewer.Id).then((name) => {
        euReviewerNameSpan.innerText = name;
      });
    }
    if (proofReaderNameSpan) {
      getUserName(workItemObject.ProofReader.Id).then((name) => {
        proofReaderNameSpan.innerText = name;
      });
    }

    if (accessesObject.CanViewReviewStatus == true) {
      if (workItemObject.ReadyForReviewDate?.ChangedDate) {
        document.querySelector(".setToReviewDate").innerText = getDateString(
          workItemObject.ReadyForReviewDate.ChangedDate
        );
      }

      if (!IsWorkItemRevision(workItemObject) || workItemObject.ContentReviewer?.EnableOnRevision) {
        if (workItemObject.ContentReviewer?.Id) {
          getUserName(workItemObject.ContentReviewer.Id).then((name) => {
            document.querySelector(".fagredaktorName").innerText = name;
          });
        }

        if (workItemObject.ContentReviewer?.ReviewedDate) {
          document.querySelector(".isFagredaktorApproved").innerText = "Godkjent: ";
          document.querySelector(".fagredaktorTime").innerText = getDateString(
            workItemObject.ContentReviewer.ReviewedDate
          );
        } else if (workItemObject.ContentReviewer?.DueDate) {
          document.querySelector(".fagredaktorTime").innerText = getDateString(
            workItemObject.ContentReviewer.DueDate
          );
          if (isDueDatePassed(workItemObject.ContentReviewer.DueDate)) {
            document.querySelector(".fagredaktorTimePart").classList.add("redfont");
          }
        }
      }

      if (
        workItemObject.IsEUReviewable &&
        (!IsWorkItemRevision(workItemObject) || workItemObject.EUReviewer?.EnableOnRevision)
      ) {
        if (workItemObject.IsEUReviewable == true) {
          if (workItemObject.EUReviewer?.Id) {
            getUserName(workItemObject.EUReviewer.Id).then((name) => {
              document.querySelector(".euReviewerName").innerText = name;
            });
          }

          if (workItemObject.EUReviewer?.ReviewedDate) {
            document.querySelector(".isEuReviewerApproved").innerText = "Godkjent: ";
            document.querySelector(".euReviewerTime").innerText = getDateString(
              workItemObject.EUReviewer.ReviewedDate
            );
          } else if (workItemObject.EUReviewer?.DueDate) {
            document.querySelector(".euReviewerTime").innerText = getDateString(
              workItemObject.EUReviewer.DueDate
            );
            if (isDueDatePassed(workItemObject.EUReviewer.DueDate)) {
              document.querySelector(".euReviewerTimePart").classList.add("redfont");
            }
          }
        }
      }

      if (!IsWorkItemRevision(workItemObject) || workItemObject.ProofReader?.EnableOnRevision) {
        if (workItemObject.ProofReader?.Id) {
          getUserName(workItemObject.ProofReader.Id).then((name) => {
            document.querySelector(".korrekturleserName").innerText = name;
          });
        }

        if (workItemObject.ProofReader?.ReviewedDate) {
          document.querySelector(".isKorrekturleserApproved").innerText = "Godkjent: ";
          document.querySelector(".korrekturleserTime").innerText = getDateString(
            workItemObject.ProofReader.ReviewedDate
          );
        } else if (workItemObject.ProofReader?.DueDate) {
          document.querySelector(".korrekturleserTime").innerText = getDateString(
            workItemObject.ProofReader.DueDate
          );
          if (isDueDatePassed(workItemObject.ProofReader.DueDate)) {
            document.querySelector(".korrekturleserTimePart").classList.add("redfont");
          }
        }
      }
    }
  }

  function publisering() {
    if (accessesObject.CanViewPublishStatus && workItemObject.Status != "ReadyForReview") {
      if (workItemObject.ReadyForPublishDate?.ChangedDate) {
        document.querySelector(".klarTilPubliseringDate").innerText = getDateString(
          workItemObject.ReadyForPublishDate.ChangedDate
        );
      }
      if (workItemObject.PublishedDate?.ChangedDate) {
        document.querySelector(".publiseringDate").innerText = getDateString(
          workItemObject.PublishedDate.ChangedDate
        );
      } else if (workItemObject.PublishedDate?.DueDate) {
        document.querySelector(".publiseringText").innerText = "Publiseres innen: ";
        document.querySelector(".publiseringDate").innerText = getDateString(
          workItemObject.PublishedDate.DueDate
        );
        if (isDueDatePassed(workItemObject.PublishedDate?.DueDate)) {
          document.querySelector(".publiseringTime").classList.add("redfont");
        }
      }
    }
  }

  function createHtmlElement(nodeName, className, id, text) {
    let element = document.createElement(nodeName);
    if (className != null) {
      element.className = className;
    }
    if (id != null) {
      element.id = id;
    }
    if (text != null) {
      element.innerText = text;
    }

    return element;
  }

  const loadAllUserInfo = async () => {
    allUsersInfo[userInfoObject.Id] = userInfoObject;
    let promisesList = [];
    if (workItemObject.ContentReviewer?.Id)
      promisesList.push(getUsersInfoObj(workItemObject.ContentReviewer?.Id));
    if (workItemObject.EUReviewer?.Id)
      promisesList.push(getUsersInfoObj(workItemObject.EUReviewer?.Id));
    if (workItemObject.ProofReader?.Id)
      promisesList.push(getUsersInfoObj(workItemObject.ProofReader?.Id));

    let coAuthorLength;
    workItemObject.SharedWith
      ? (coAuthorLength = workItemObject.SharedWith.length)
      : (coAuthorLength = 0);

    if (coAuthorLength > 0) {
      for (let index = 0; index < coAuthorLength; index++) {
        promisesList.push(getUsersInfoObj(workItemObject.SharedWith[index]));
      }
    }
    try {
      await Promise.all(promisesList);
    } finally {
      setUsersInfoStatus("finished");
    }
  };

  async function getUsersInfoObj(id) {
    let userObj = "Ukjent";
    if (id) {
      if (!allUsersInfo[id] || allUsersInfo[id] == null) {
        await APICalls.getUserInfoById(id, userInfoObject.Id, decodedTokenObject)
          .then((result) => {
            allUsersInfo[id] = result;
            userObj = result;
          })
          .catch((error) => {
            sendLog("ERROR", "Getting user failed Id:  " + id);
          });
      } else {
        userObj = allUsersInfo[id];
      }
    } else {
      sendLog("WARNING", "UserId is undefined or null. Id:  " + id);
    }
    return userObj;
  }

  async function getUserName(id) {
    let name = "Ukjent";
    await getUsersInfoObj(id).then((result) => {
      if (result != "Ukjent" && result?.Name) {
        name = result.Name;
        return name;
      }
    });
    return name;
  }

  function getDateString(date) {
    if (date && date != null) {
      let t = new Date(date);
      const y = t.getFullYear().toString();
      const m = (t.getMonth() + 1).toString();
      let d = t.getDate().toString();
      return (d.length == 1 ? "0" : "") + d + "." + (m.length == 1 ? "0" : "") + m + "." + y;
    } else {
      return "Ukjent";
    }
  }

  function setRevisionClicked() {
    let contentReviewerCheckbox = document.querySelector(".contentReviewerCheckbox");
    let euReviewerCheckbox = document.querySelector(".euReviewerCheckbox");
    let proofReaderCheckbox = document.querySelector(".proofReaderCheckbox");
    let contentReviewer = null;
    let eUReviewer = null;
    let proofReader = null;
    if (contentReviewerCheckbox.checked && !contentReviewerCheckbox.disabled) {
      contentReviewer = true;
    }
    if (euReviewerCheckbox.checked && !euReviewerCheckbox.disabled) {
      eUReviewer = true;
    }
    if (proofReaderCheckbox.checked && !proofReaderCheckbox.disabled) {
      proofReader = true;
    }
    if (contentReviewer || eUReviewer || proofReader) {
      APICalls.enableOnRevision(
        contentReviewer,
        eUReviewer,
        proofReader,
        userInfoObject,
        workItemObject,
        decodedTokenObject
      ).then((result) => {
        handleUpdate();
        if (contentReviewer) workItemObject.ContentReviewer = result.ContentReviewer;
        if (eUReviewer) workItemObject.EUReviewer = result.EUReviewer;
        if (proofReader) workItemObject.ProofReader = result.ProofReader;
        setWorkItemObject(workItemObject);
        setReloadVerktoy(!reloadVerktoy);
        forceUpdate();
      });
    }
  }

  function isDueDatePassed(time) {
    let givenTime = new Date(time);
    const today = new Date();
    const todayYear = today.getFullYear();
    let givenTimeYear = givenTime.getFullYear();
    if (todayYear > givenTimeYear) {
      return true;
    }
    const todayMonth = today.getMonth();
    let givenTimeMonth = givenTime.getMonth();
    if (todayMonth > givenTimeMonth) {
      return true;
    }
    const todayDay = today.getDay();
    let givenTimeDay = givenTime.getDay();
    if (todayDay > givenTimeDay) {
      return true;
    }
    return false;
  }

  function AllReviewersHaveApproved() {
    // For revision workitems, at least one of the reviewers must be activated
    if (!ReviewerHasApproved(workItemObject.ContentReviewer)) {
      return false;
    }
    if (workItemObject.IsEUReviewable && !ReviewerHasApproved(workItemObject.EUReviewer)) {
      return false;
    }
    if (!ReviewerHasApproved(workItemObject.ProofReader)) {
      return false;
    }
    return true;
  }

  function ReviewerHasApproved(reviewer) {
    if (!reviewer || reviewer == null) return false;
    if (
      reviewer.ReviewedDate ||
      (IsWorkItemRevision(workItemObject) && !reviewer?.EnableOnRevision)
    )
      return true;

    return false;
  }

  function changeWorkItemStatus(newStatus, omitNotification = false) {
    APICalls.setWorkItemStatus(
      newStatus,
      omitNotification,
      userInfoObject,
      workItemObject,
      decodedTokenObject
    )
      .then((result) => {
        if (result.Success == true) {
          sendLog("INFO", "Successful set workitem status", newStatus);
          sendMetric("SetWorkitemStatus", "", "Success", newStatus);
          handleUpdate();
        } else {
          sendLog("ERROR", "Failed set workitem status", newStatus);
          sendMetric("SetWorkitemStatus", "", "Failed", newStatus);
          handleActionOfErrorBox("ChangeStatusFailed");
        }
      })
      .catch((e) => {
        console.log("Error setting workitem status");
        sendLog("ERROR", "Failed set workitem status", newStatus);
        sendMetric("SetWorkitemStatus", "", "Failed", newStatus);
        handleActionOfErrorBox("ChangeStatusFailed");
      });
  }

  function publiserButtonClicked() {
    let publiseringButton = document.querySelector("#docopspublish");
    publiseringButton.disabled = true;
    let publiserButtonText = document.querySelector(".publiserButtonText");
    publiserButtonText.innerText = "Wait";
    let publiseringError = document.querySelector(".publiseringError");
    publiseringError.style.display = "none";
    let publiseringSuccess = document.querySelector(".publiseringSuccess");
    publiseringSuccess.style.display = "none";
    APICalls.docOpsPublisering(userInfoObject, workItemObject, decodedTokenObject)
      .then((result) => {
        publiserButtonText.innerText = "Publiser";
        publiseringButton.disabled = false;
        if (result.AllIsPlaced == true) {
          publiseringSuccess.style.display = "block";
          sendLog("INFO", "Successfully set ready to publish", "DocOps");
          sendMetric("In DocOps mode set ready to publish");
          handleUpdate();
        } else {
          publiseringError.style.display = "block";
        }
      })
      .catch((err) => {
        sendLog("ERROR", "Faild to set ready to publish", "DocOps");
        publiserButtonText.innerText = "Publiser";
        publiseringButton.disabled = false;
        publiseringError.style.display = "block";
        handleActionOfErrorBox("SetReadyForPublishFailed");
      });
  }

  const docOpsActiverClicked = () => {
    const docOpsMode = document.querySelector("#lawTab").classList.contains("docOpsMode");
    if (docOpsMode == false) {
      document.querySelector(".DocOpsPublisering").style.display = "block";
      document.querySelector(".docOpsButoonText").innerText = " Deaktiver";
      document.querySelector("#lawTab").classList.add("docOpsMode");
    } else {
      document.querySelector(".DocOpsPublisering").style.display = "none";
      document.querySelector(".docOpsButoonText").innerText = " Aktiver";
      document.querySelector("#lawTab").classList.remove("docOpsMode");
      handleUpdate();
    }
  };

  const checkForSetRevisionButton = () => {
    let contentReviewerCheckbox = document.querySelector(".contentReviewerCheckbox");
    let euReviewerCheckbox = document.querySelector(".euReviewerCheckbox");
    let proofReaderCheckbox = document.querySelector(".proofReaderCheckbox");
    let submitRevisionButton = document.querySelector("#submitRevisionButton");
    submitRevisionButton.disabled = true;
    submitRevisionButton.removeEventListener("click", setRevisionClicked);

    if (
      (contentReviewerCheckbox.checked && contentReviewerCheckbox.disabled == false) ||
      (euReviewerCheckbox.checked && euReviewerCheckbox.disabled == false) ||
      (proofReaderCheckbox.checked && proofReaderCheckbox.disabled == false)
    ) {
      submitRevisionButton.disabled = false;
      submitRevisionButton.addEventListener("click", setRevisionClicked);
    }
  };

  const toggleSetReviewButton = () => {
    let checkBoxContainer = document.getElementById("setReviewCheckbox");
    if (checkBoxContainer) {
      if (checkBoxContainer.checked === true) {
        setSetReviewButtonStatus(true);
      } else {
        setSetReviewButtonStatus(false);
      }
    } else {
      setSetReviewButtonStatus(false);
    }
  };

  function IsWorkItemRevision(wi) {
    if (wi && (wi.IsRevision == true || wi.IsAuthorValidated == true)) {
      return true;
    }
    return false;
  }

  function sendPingTo(receiver) {
    let senderId = userInfoObject.Id;
    let receiverId = "";
    if (receiver == "Author") {
      receiverId = workItemObject.AuthorId;
    } else if (receiver == "ContentReviewer") {
      receiverId = workItemObject.ContentReviewer?.Id;
    }

    if (receiverId) {
      APICalls.ping(senderId, receiverId, workItemObject, userInfoObject, decodedTokenObject)
        .then((result) => {
          if (result.Success == true) {
            sendLog("INFO", "Notification to " + receiverId, "Merknader in Kword");
            sendMetric("Notification", "ping in kword", "Success", "receiver " + receiverId);
            if (receiver == "Author") {
              handleActionOfMessageBox("successPingToAuthor");
            } else if (receiver == "ContentReviewer") {
              handleActionOfMessageBox("successPingToContentReviewer");
            }
          } else {
            sendLog(
              "ERROR",
              "Notification to " + receiverId,
              "Merknader in Kword, result is failed"
            );
            handleActionOfErrorBox("FailedPing");
          }
        })
        .catch((e) => {
          console.log("Failed sending notification");
          sendLog("ERROR", "Notification to " + receiverId, "Merknader in Kword");
          handleActionOfErrorBox("FailedPing");
        });
    }
  }

  const handleActionOfMessageBox = (type) => {
    setMessageBoxProp("hideMessageBox");
    setErrorBoxProp("hideErrorBox");
    setMessageBoxProp(type);
  };

  const handleActionOfErrorBox = (type) => {
    setErrorBoxProp("hideErrorBox");
    setMessageBoxProp("hideMessageBox");
    setErrorBoxProp(type);
  };

  function CanShowSetReadyForPublishButton() {
    if (AllReviewersApproved) {
      if (!IsWorkItemRevision(workItemObject)) {
        return true;
      } else {
        if (!accessesObject.roles.Author) {
          // It means that user is either devops or karnovEditor
          return true;
        } else {
          if (
            workItemObject.ContentReviewer?.EnableOnRevision ||
            workItemObject.ProofReader?.EnableOnRevision
          ) {
            return true;
          }
        }
      }
    }
    return false;
  }

  function approveReview(type, isSetReadyForPublish = false, omitNotification = false) {
    APICalls.reviewApproval(type, workItemObject, userInfoObject, decodedTokenObject)
      .then((result) => {
        if (result.Success == true) {
          sendLog("INFO", `Ktext: Reviewer approved - ${type}`);
          sendMetric("ReviewerApproved", "", "Success", type);
          if (isSetReadyForPublish) {
            changeWorkItemStatus("ReadyForPublish", omitNotification);
          } else {
            handleUpdate();
          }
        } else {
          sendLog("ERROR", `Ktext: Failed reviewer approving - ${type}`);
          sendMetric("ReviewerApproved", "", "Failed", type);
          handleActionOfErrorBox("ApproveReviewFailed");
        }
      })
      .catch((e) => {
        console.log("Error approving for reviewer");
        sendLog("ERROR", `Ktext: Failed reviewer approving - ${type}`);
        sendMetric("ReviewerApproved", "", "Failed", type);
        handleActionOfErrorBox("ApproveReviewFailed");
      });
  }

  const sendLog = (level, message, method, params) => {
    APICalls.log(
      level,
      message,
      method,
      params,
      workItemObject,
      userInfoObject,
      decodedTokenObject
    );
  };

  const sendMetric = (category, subCategory, status, tag, message) => {
    APICalls.logMetric(
      category,
      subCategory,
      status,
      tag,
      message,
      workItemObject,
      userInfoObject,
      decodedTokenObject
    );
  };

  return (
    <React.Fragment>
      {usersInfoStatus == "loading" && <Loading />}
      {usersInfoStatus == "finished" && (
        <React.Fragment>
          <div className="verktoyMenu">
            {/* DOCOPS */}

            {userInfoObject.IsKarnovDevOps == true && (
              <div id="docopsmenu" className="verktoyItem docOps">
                <div className="interactionmenuhead verktoyHeadings1">DocOps</div>
                <div className="verktoyHeadings2">Aktiver for å legge inn note nummer manuelt</div>
                <button
                  onClick={docOpsActiverClicked}
                  type="button"
                  className="ktoolbutton-large docOpsModeActivator"
                  title="Aktiver DocOps modus"
                >
                  <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                    <i className="bi bi-gear"></i>
                  </span>
                  <span className="ktoolbutton-label docOpsButoonText"> Aktiver</span>
                </button>
                <div className="DocOpsPublisering">
                  <div className="verktoyHeadings2">
                    Publiser replasserte noter ved versjonsoppgradering.
                  </div>
                  <button
                    onClick={publiserButtonClicked}
                    type="button"
                    id="docopspublish"
                    className="ktoolbutton-large"
                    title="Publiser for versjonsoppgradering"
                  >
                    {/* <i className="redfont ms-Icon ms-Icon--Warning"></i> */}
                    <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                      <i className="bi bi-send"></i>
                    </span>
                    <span className="ktoolbutton-label publiserButtonText"> Publiser</span>
                  </button>
                  <span className="publiseringError">Error. (check console)</span>
                  <span className="publiseringSuccess">Vellykket publisering!</span>
                </div>
              </div>
            )}

            {/* REVISION */}

            {accessesObject.CanViewRevision && (
              <div className="verktoyItem revision">
                <div className="verktoyHeadings1">Revisjon</div>
                <div className="verktoyHeadings2">Handling:</div>
                <div className="verktoyHeadings2">
                  <div className="fagredaktor">
                    <input
                      className="contentReviewerCheckbox"
                      type="checkbox"
                      value="1"
                      onChange={checkForSetRevisionButton}
                      disabled={true}
                    />
                    <label className="contentReviewerText labelText">
                      Aktiver fagredaktør (ikke satt)
                    </label>
                  </div>
                  <div className="euReviewer">
                    <input
                      className="euReviewerCheckbox"
                      type="checkbox"
                      value="2"
                      onChange={checkForSetRevisionButton}
                      disabled={true}
                    />
                    <label className="euReviewerText labelText">
                      Aktiver EU redaktør (ikke satt)
                    </label>
                  </div>
                  <div className="proofReader">
                    <input
                      className="proofReaderCheckbox"
                      type="checkbox"
                      value="3"
                      onChange={checkForSetRevisionButton}
                      disabled={true}
                    />
                    <label className="proofReaderText labelText">
                      Aktiver korrekturleser (ikke satt)
                    </label>
                  </div>
                </div>
                <button
                  id="submitRevisionButton"
                  className="ktoolbutton-large"
                  title="all set"
                  // onClick={setRevisionClicked}
                  disabled={true}
                >
                  <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                    <i className="ms-Icon ms-Icon--Like"></i>
                  </span>
                  <span className="ktoolbutton-label">Sett</span>
                </button>
              </div>
            )}

            {/* SHARED WITH */}

            {accessesObject.CanViewCoAuthors && (
              <div className="verktoyItem Deling">
                <div className="verktoyHeadings1">Deling</div>
                <div className="verktoyHeadings2">Forfatter:</div>
                <div className="verktoyHeadings4 authorName">Ukjent</div>
                <div className="verktoyHeadings2">Dokument er delt med:</div>
                <div className="coAuthorNames">
                  <div className="verktoyHeadings4">dokumentet har ikke blitt delt med noen.</div>
                </div>
                {workItemObject.SharedWith && workItemObject.SharedWith.length > 0 && (
                  <div className="verktoyHeadings2">
                    De dokumentet er delt med har skriverettigheter, men vil ikke kunne legge
                    til/slette noter.
                  </div>
                )}
              </div>
            )}

            {/* REVIEW */}

            {(accessesObject.CanSetReadyForReview || accessesObject.CanViewReviewStatus) && (
              <div className="verktoyItem fagligVurdering">
                <div className="verktoyHeadings1">Faglig vurdering</div>
                {accessesObject.CanSetReadyForReview == true && (
                  <>
                    <div className="verktoyHeadings4">
                      Når dokumentet settes til vurdering, vil bidragsytere miste tilgang. Du kan
                      fortsatt endre innholdet i dokumentet på bakgrunn av tilbakemeldinger, men
                      større endringer må avtales med Karnov.
                    </div>

                    <div className="setReviewStatusDiv">
                      <div>
                        <input
                          className="form-check-input"
                          type="checkbox"
                          value=""
                          id="setReviewCheckbox"
                          onClick={toggleSetReviewButton}
                        />
                        <span className="form-check-label" id="setReviewCheckboxLabel">
                          Jeg bekrefter at manuset er fullstendig.
                        </span>
                      </div>
                      <button
                        type="button"
                        id="buttonreadyforapproval"
                        className="ktoolbutton-large"
                        title="Sett til vurdering"
                        disabled={!setReviewButtonStatus}
                        onClick={() => changeWorkItemStatus("ReadyForReview")}
                      >
                        <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                          <i className="ms-Icon ms-Icon--ChangeEntitlements"></i>
                        </span>
                        <span className="ktoolbutton-label">Sett til vurdering</span>
                      </button>
                    </div>
                    <div className="verktoyHeadings2">Vurderes av:</div>
                    <div className="reviewersNames">
                      {workItemObject?.ContentReviewer?.Id &&
                        (!IsWorkItemRevision(workItemObject) ||
                          workItemObject.ContentReviewer?.EnableOnRevision) && (
                          <div>
                            <span
                              className="contentReviewerName"
                              style={{ fontWeight: "600", marginLeft: "13px" }}
                            ></span>
                            <span> (Fagredaktør)</span>
                          </div>
                        )}
                      {workItemObject.EUReviewer?.Id &&
                        workItemObject.IsEUReviewable &&
                        (!IsWorkItemRevision(workItemObject) ||
                          workItemObject.EUReviewer?.EnableOnRevision) && (
                          <div>
                            <span
                              className="euReviewerName"
                              style={{ fontWeight: "600", marginLeft: "13px" }}
                            ></span>
                            <span> (EU redaktør)</span>
                          </div>
                        )}
                      {workItemObject?.ProofReader?.Id &&
                        (!IsWorkItemRevision(workItemObject) ||
                          workItemObject.ProofReader?.EnableOnRevision) && (
                          <div>
                            <span
                              className="proofReaderName"
                              style={{ fontWeight: "600", marginLeft: "13px" }}
                            ></span>
                            <span> (Korrektur)</span>
                          </div>
                        )}
                    </div>
                  </>
                )}

                {accessesObject.CanViewReviewStatus && (
                  <>
                    {(accessesObject.roles.ProofReader || accessesObject.CanApproveReviews) &&
                      !ReviewerHasApproved(workItemObject.ProofReader) && (
                        <>
                          <p className="approvalHeading">
                            Trykk denne knappen dersom du har gitt tilbakemeldinger som fører til at
                            forfatter må foreta rettelser i manus:
                          </p>
                          <button
                            type="button"
                            className="ktoolbutton-large"
                            title="Trykk denne knappen dersom du har gitt tilbakemeldinger som fører til at forfatter må foreta rettelser i manus."
                            onClick={() => sendPingTo("Author")}
                          >
                            <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                              <i className="ms-Icon ms-Icon--PeopleAlert"></i>
                            </span>
                            <span className="ktoolbutton-label">Send merknader</span>
                          </button>
                        </>
                      )}

                    <>
                      {(accessesObject.roles.ContentReviewer || accessesObject.CanApproveReviews) &&
                        !ReviewerHasApproved(workItemObject.ContentReviewer) &&
                        (!IsWorkItemRevision(workItemObject) ||
                          workItemObject.ContentReviewer?.EnableOnRevision) && (
                          <>
                            <p className="approvalHeading">
                              Godkjenningen gjelder for din rolle som: Fagredaktør
                            </p>
                            <p className="approvalHeading">
                              Trykk denne knappen dersom du er ferdig med den faglig gjennomgangen
                              av manuset:
                            </p>
                            <button
                              type="button"
                              className="ktoolbutton-large"
                              title="Trykk denne knappen dersom du er ferdig med den faglig gjennomgangen av manuset."
                              onClick={() => approveReview("ContentReviewer", false)}
                            >
                              <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                                <i className="ms-Icon ms-Icon--Like"></i>
                              </span>
                              <span className="ktoolbutton-label">Manus er vurdert</span>
                            </button>
                          </>
                        )}
                      {(accessesObject.roles.EUReviewer || accessesObject.CanApproveReviews) &&
                        workItemObject.IsEUReviewable &&
                        !ReviewerHasApproved(workItemObject.EUReviewer) &&
                        (!IsWorkItemRevision(workItemObject) ||
                          workItemObject.EUReviewer?.EnableOnRevision) && (
                          <>
                            <p className="approvalHeading">
                              Godkjenningen gjelder for din rolle som: EU redaktør
                            </p>
                            <p className="approvalHeading">
                              Trykk denne knappen dersom du er ferdig med den faglig gjennomgangen
                              av manuset:
                            </p>
                            <button
                              type="button"
                              className="ktoolbutton-large"
                              title="Trykk denne knappen dersom du er ferdig med den faglig gjennomgangen av manuset."
                              onClick={() => approveReview("EUReviewer", false)}
                            >
                              <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                                <i className="ms-Icon ms-Icon--Like"></i>
                              </span>
                              <span className="ktoolbutton-label">Godkjenn noter</span>
                            </button>
                          </>
                        )}
                      {(accessesObject.roles.ProofReader || accessesObject.CanApproveReviews) &&
                        !ReviewerHasApproved(workItemObject.ProofReader) && (
                          <>
                            <p className="approvalHeading">
                              Godkjenningen gjelder for din rolle som: Korrekturleser
                            </p>
                            <p className="approvalHeading">
                              Trykk denne knappen dersom du er ferdig med den faglig gjennomgangen
                              av manuset:
                            </p>
                            <button
                              type="button"
                              className="ktoolbutton-large"
                              title="Trykk denne knappen dersom du er ferdig med den faglig gjennomgangen av manuset."
                              onClick={() => approveReview("ProofReader", false)}
                            >
                              <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                                <i className="ms-Icon ms-Icon--Like"></i>
                              </span>
                              <span className="ktoolbutton-label">Godkjenn noter</span>
                            </button>
                            {IsWorkItemRevision(workItemObject) && (
                              <button
                                type="button"
                                className="ktoolbutton-large"
                                title="Trykk denne knappen dersom du er ferdig med den faglig gjennomgangen av manuset."
                                onClick={() => approveReview("ProofReader", true, true)}
                              >
                                <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                                  <i className="ms-Icon ms-Icon--Like"></i>
                                </span>
                                <span className="ktoolbutton-label">
                                  Godkjenn noter og sett klar til publisering
                                </span>
                              </button>
                            )}
                          </>
                        )}
                    </>

                    <div className="verktoyHeadings2 sattKlarText">
                      <span>Satt klar til vurdering: </span>
                      <span className="setToReviewDate">Ukjent</span>
                      <div>{AllReviewersApproved ? "Vurdert av:" : "Vurderes av:"}</div>
                    </div>

                    <div className="fgNamesPart">
                      {(!IsWorkItemRevision(workItemObject) ||
                        workItemObject.ContentReviewer?.EnableOnRevision) && (
                        <>
                          <div className="fgNamePart">
                            <span className="fgName fagredaktorName">Ikke satt</span>
                            <span> (Fagredaktør)</span>
                          </div>
                          <div className="fgTimePart fagredaktorTimePart">
                            <span className="isFagredaktorApproved">Frist: </span>
                            <span className="fagredaktorTime"> Ukjent</span>
                          </div>
                        </>
                      )}

                      {workItemObject.IsEUReviewable &&
                        (!IsWorkItemRevision(workItemObject) ||
                          workItemObject.EUReviewer?.EnableOnRevision) && (
                          <>
                            <div className="fgNamePart">
                              <span className="fgName euReviewerName">Ikke satt</span>
                              <span> (EU/EØS)</span>
                            </div>
                            <div className="fgTimePart euReviewerTimePart">
                              <span className="isEuReviewerApproved">Frist: </span>
                              <span className="euReviewerTime"> Ukjent</span>
                            </div>
                          </>
                        )}
                      {(!IsWorkItemRevision(workItemObject) ||
                        workItemObject.ProofReader?.EnableOnRevision) && (
                        <>
                          <div className="fgNamePart">
                            <span className="fgName korrekturleserName">Ikke satt</span>
                            <span> (Korrektur)</span>
                          </div>
                          <div className="fgTimePart korrekturleserTimePart">
                            <span className="isKorrekturleserApproved">Frist: </span>
                            <span className="korrekturleserTime"> Ukjent</span>
                          </div>
                        </>
                      )}
                    </div>
                  </>
                )}
              </div>
            )}

            {/* PUBLISHING */}

            {accessesObject.CanViewPublishStatus &&
              (workItemObject.Status != "ReadyForReview" || AllReviewersApproved) && (
                <div className="verktoyItem publisering">
                  <div className="verktoyHeadings1">Publisering</div>
                  {accessesObject.CanSetReadyForPublish && CanShowSetReadyForPublishButton() && (
                    <div className="verktoyHeadings2 makeReadyForPublish">
                      <p>
                        <i className="redfont ms-Icon ms-Icon--Warning"></i> Karnov foretar en siste
                        sjekk før notene sendes til Lovdata.
                      </p>
                      <button
                        onClick={() => changeWorkItemStatus("ReadyForPublish")}
                        type="button"
                        id="buttonreadyforpublish"
                        className="ktoolbutton-large"
                        title="Lever inn til Karnov for publisering hos Lovdata"
                      >
                        <span className="ktoolbutton-icon-large ms-fontColor-themePrimary">
                          <i className="bi bi-send"></i>
                        </span>
                        <span className="ktoolbutton-label">Lever til Karnov</span>
                      </button>
                    </div>
                  )}

                  {workItemObject.Status != "ReadyForReview" && (
                    <>
                      <div className="verktoyHeadings2 klarTilPublisering">
                        <span>Satt klar til publisering: </span>
                        <span className="klarTilPubliseringDate"> Ukjent</span>
                      </div>
                      <div className="verktoyHeadings2 publiseringTime">
                        <span className="publiseringText">Publisert: </span>
                        <span className="publiseringDate"> Ukjent</span>
                      </div>
                    </>
                  )}
                </div>
              )}
          </div>
        </React.Fragment>
      )}
    </React.Fragment>
  );
}
